import Image from 'next/image';
import React, { useEffect, useRef, useState } from 'react';
import { Button } from 'reactstrap';
import styles from '../.././../styles/HomeLanding/HomeLanding.module.css'

const TestimonialSectionUAE = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isInView, setIsInView] = useState(false);
  const sectionRef = useRef(null);
  
  const data = [
    {
      icon: '/assets/HomeLanding/heineken.svg',
      description: 'We explored numerous POS solutions for our pubs and grocery stores, but none provided us with the ideal fit until we discovered QueueBuster. The QueueBuster POS solution is highly flexible and reasonably priced.',
      img: '/assets/HomeLanding/AvatarHeineken.png',
      name: 'Chima Uba',
      disignation: <> Head, Digital Products & Transformation <br />Heineken, Nigeria</>,
      backgroundcolor: '#FEF4E8',
       width: '15rem',
        height: "4rem"
    },
    {
      icon: '/assets/HomeLanding/Doroki-logo.webp',
      description: 'At Paga Group, our mission is to deliver financial freedom to a billion Africans. Partnering with QueueBuster enables us to equip our merchant network with a powerful, all-in-one POS software solution that streamlines operations, enhances customer experiences, and fosters business growth.',
      img: '/assets/HomeLanding/AvatarPaga.png',
      name: 'Tayo Oviosu',
      disignation: <>Founder & CEO <br /> Paga Group</>,
      backgroundcolor: '#F0F9FF',
       width: '13rem',
       height: "4rem"
    },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
        }
      },
      {
        threshold: 0.1,
      }
    );
  
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
  
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === data.length - 1 ? 0 : prevIndex + 1
      );
    }, 10000);  
  
    return () => clearInterval(interval);  
  }, [data.length]);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? data.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === data.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div style={{ maxWidth: '1850px', margin: '0 auto' }}>
    <div style={{ display: 'flex',  margin: '0 17rem'}} ref={sectionRef}>
      <div style={{ width: '30%', padding: '5rem 0',  }}>
        <Button style={{ backgroundColor: "#6CC7FF", padding: "1rem 2rem", border: "none", borderRadius: "4rem", fontSize: "1.5rem" }}> Client Testimonials</Button>
        {data.map((item, index) => (
          <div
            key={index}
            style={{
              display: index === currentIndex ? 'block' : 'none',
            }}
          >
            <div style={{ display: 'flex', flexDirection: "column", justifyContent: "space-between", alignContent: "space-between", margin: "2rem 0" }}>
              <h4 style={{ fontSize: "2.6rem", fontFamily: "GilroyBold" }}>
                <span style={{ display: 'flex', position: 'relative' }}>Success stories
                  <div style={{
                    position: 'absolute',
                    height: '0.5rem',
                    width: isInView ? '19rem' : '0',
                    bottom: "0rem",
                    transition: 'width 1s ease-in-out',
                    overflow: 'hidden'
                  }}>
                    <Image src='/assets/HomeLanding/VectorLine.webp' alt='Modern POS machine for Dubai businesses' fill  />
                  </div>
                </span>
                 you can trust
              </h4>

              <div style={{ display: "flex", gap: "2rem", margin: "1rem 0" }}>
                <div
                  onClick={handlePrev}
                  className={styles.expand_circle_left}
                >
                  <Image src='/assets/HomeLanding/expand_circle_left.svg' alt='Billing' fill />
                </div>
                <div
                  
                 className={styles.expand_circle_right}
                 onClick={handleNext}>
                  <Image src='/assets/HomeLanding/expand_circle_right.svg' alt='POS' fill />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div style={{ width: "70%" }}>
        {data.map((item, index) => (
          <div
            key={index}
            style={{
              display: index === currentIndex ? 'block' : 'none',
              padding: '3rem',
              margin: '1rem 0',
              backgroundColor: item.backgroundcolor,
              borderRadius: "2rem",
              height: "34rem",
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: "space-between", height: "100%" }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: "1rem" }}>
                <div style={{ position: 'relative', width: item.width, height: item.height, left:"0" }}><Image src={item.icon} fill alt='POS software with loyalty program UAE' /></div>
                <h4 style={{ fontSize: "1.9rem", fontFamily: "GilroyBold" }}>{item.description}</h4>
              </div>
              <div style={{ display: "flex", gap: "2rem", alignItems: "center", alignContent: 'center' }}>
                <div style={{ position: 'relative', width: '8rem', height: "8rem" }}><Image src={item.img} fill alt={item.name} /></div>
                <div style={{ marginBottom: '-1rem' }}>
                  <p style={{ fontSize: '2rem', fontFamily: 'GilroySemiBold', marginBottom: '-0.1rem' }}>{item.name}</p>
                  <p>{item.disignation}</p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
    </div>
  );
};

export default TestimonialSectionUAE;